import { Vector } from '@inter-ikea-core/core';
import { CoreApi, ShapeTypeEnum } from '@inter-ikea-storageone/range';

//Used to send in a copy of the planned solution to the Save To Profile API
export const createDesignConfiguration = (
  coreApi: CoreApi,
  currentProppingAgeGroup?: string,
  wallShape?: {
    dimensions: Vector[] | undefined;
    type: ShapeTypeEnum | undefined;
  }
): Record<string, object | string | number | boolean> => {
  const sceneConfiguration = JSON.parse(coreApi.saveScene());
  return {
    ...sceneConfiguration,
    proppingAgeGroup: currentProppingAgeGroup,
    wallShape: wallShape
  };
};
